import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import {GAMING_HISTORY_PAGE, SESSION_HISTORY_PAGE, STICKY} from "../../../themes/css-global-classes";

const CommonStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.colors.bodyBackground};
  position: sticky;

  &.${STICKY}{
    top: 0;
    z-index: 100;
  }
`;

export const LobbyHeaderPCBox = styled(CommonStyles)`
  padding-top: 15px;
  padding-bottom: 12px;

  &.${STICKY}{
    right:0;
    left: ${props => props.theme.layout.navbar.width};
    background-image: url(${props => props.theme.images.texture.toString()});
  }

  .${GAMING_HISTORY_PAGE} &, .${SESSION_HISTORY_PAGE} &{
      padding-bottom: 0;
  }
`;

export const LobbyHeaderMobileBox = styled(CommonStyles)`
  padding-top: 10px;
  &.${STICKY}{
      width:100%;
  }
`;

export const LobbyHeaderDefaultBox = styledByDevice(LobbyHeaderPCBox, LobbyHeaderMobileBox);